import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

class GetVehiclesInfoByPlateVehiclesService extends Service {
  constructor({httpVehiclesRepository, vehicleEntityFactory}) {
    super()
    this._httpVehiclesRepository = httpVehiclesRepository
    this._vehicleEntityFactory = vehicleEntityFactory
  }

  @inlineError
  async execute({getVehiclesInfoByPlateRequest}) {
    const [error, vehicleEntity] = await this._httpVehiclesRepository.getVehiclesInfoByPlate({
      getVehiclesInfoByPlateRequest
    })

    if (error) return Promise.reject(error)

    return vehicleEntity
  }
}

export {GetVehiclesInfoByPlateVehiclesService}
